<ic-top-bar [qaNodes]="topBarQa" (toggle)="toggle.emit()" />

<div [class]="legacyWrapper() ? 'ic-page-body' : 'ic-app-frame__body'">
  <ng-content />
</div>
